module.exports = __webpack_public_path__ + "static/media/dorp.a5e1f172.jpg";